import { Component, Shark } from "shark-mvc";
import { Modal } from "bootstrap";

import tinymce from "tinymce";
import "tinymce/icons/default";
import "tinymce/plugins/autoresize";
import "tinymce/plugins/code";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/paste";
import "tinymce/plugins/table";
import "tinymce/skins/ui/oxide/skin.css";
import "tinymce/themes/silver";

import templateContent from "./note-modal.html";
import Note from "../../models/Note";
import noteManager from "../../controllers/noteManager";

class NoteModalComponent extends Component {
	constructor () {
		super("noteModalComponent");
		this.addTemplate("", templateContent);
	}

	addNoteBtn_clickHandler (event, data) {
		const taskGuid = data.taskGuid;
		const currNote = new Note({
			status: 1,
			taskGuid,
		});

		Shark.set({currNote});
		Shark.render();
		this.open();
	}

	afterLoad () {
		const modalNode = document.querySelector("#noteModal");

		if (modalNode) {
			this.modal = new Modal(modalNode, {
				keyboard: false
			});
		}

		tinymce.init({
			entity_encoding : "raw",
			init_instance_callback: editor => {
				console.log({editor});
				this.tinyEditor = editor;
				this.tinyInited = true;
			},
			max_height: 650,
			plugins: ["autoresize", "paste", "link", "code", "lists", "table"],
			selector: "textarea#noteModalBodyField",
		});
	}
	
	close () {
		if (this.modal) {
			this.modal.hide();
			
			// const body = document.querySelector("body");
			// body.classList.remove("modal-open");
			// body.style.removeProperty("padding-right");
			
			this.set("open", false);
		}
	}

	init () {
		this.set("open", false);
	}
	
	
	noteModalCloseBtn_clickHandler () {
		// Dave: bisogna validare l'eventuale nota non salvata.
		this.close();
	}
	
	noteModalSavetn_clickHandler () {
		const { currNote } = Shark.get();
		console.log({currNote});

		if (currNote) {
			currNote.set({
				body: this.tinyEditor.getContent(),
			});

			const errors = currNote.validate();

			if (errors.length > 0) {
				alert(errors.map(item => item.error).join("\n"));
			}
			else {
				noteManager.save(currNote)
				.then(() => {
					this.close();
					// this.refreshList(Shark.$store.currActivity.guid);
				});
			}
		}

	}

	open () {
		if (this.modal) {
			this.modal.show();
			this.set("open", true);
		}
	}
}

const noteModalComponent = new NoteModalComponent();

Shark.registerComponent(noteModalComponent);

export default noteModalComponent;
